/* ----------------------------------------------------------------------------
   KLARNA MESSAGE UNDER THE CONFIGURATOR'S ADD TO CART  (Plush + Oak)
   ----------------------------------------------------------------------------
   sections/po-configurator.liquid renders EVERY app block into one fixed slot
   directly under the price, so Klarna's block cannot be positioned next to the
   button from the theme editor and a second Klarna block would only stack in
   that same slot. This adds a placement right after the add-to-cart form.

   The figure is priced off the configurator's running total, not the bed's own
   price: add a $449 bolster to a $2,597 Brynn and the summary reads $3,046, so
   this line reads $146/month while the app block above still reads $125. The
   app block's placement is never touched.

   Klarna still renders the copy. We only supply the amount — the monthly
   figure, the term, the 0% claim and the "Check purchase power" disclosure link
   are all Klarna's, which is what keeps the credit representation theirs and
   correct. Nothing here invents a rate.

   ---------------------------------------------------------------------------
   ORDERING — the part that matters
   ---------------------------------------------------------------------------
   Klarna's app-block script enumerates every <klarna-placement> on the page and
   forces the product price onto all of them. A configurator change triggers
   that re-run, so a naive observer writes the total and is immediately undone:

     [klarna-osm] Updating placements with new amount
                  {placements: Array(2), purchaseAmount: 259700}
     [klarna-osm] amount changed from 304600 to 259700

   Klarna's updater does NOT re-run in response to our writes — it only reacts to
   the configurator. So the fix is ordering, not force: re-apply on a short
   ladder of delays after the total changes, and the last write stands. Verified
   2026-09-12 — one write lands at +400ms and the +900/+1600/+2600 checks find it
   already correct, in both directions. Each write is conditional, so this is a
   bounded set of checks, never a loop fighting the vendor script.
   ---------------------------------------------------------------------------- */
(function () {
  if (window.__poKlarnaAtc) return;
  window.__poKlarnaAtc = true;

  /* Amount is ours; everything else is copied from the app block. */
  var COPIED = ['data-key', 'data-locale', 'data-theme'];
  var SETTLE_DELAYS = [400, 900, 1600, 2600];
  var refreshTimer;

  function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      var k = window.Klarna && window.Klarna.OnsiteMessaging;
      if (k && typeof k.refresh === 'function') k.refresh();
    }, 120);
  }

  /* "$3,046" -> 304600. A trailing ".50"/",50" is cents; any other separator is
     a thousands mark. Covers the en-US and en-CA formats this store sells in.
     Returns null on anything unreadable, and the caller falls back to the app
     block's own amount rather than guessing. */
  function toCents(text) {
    if (!text) return null;
    var digits = String(text).replace(/[^\d.,]/g, '');
    if (!digits) return null;

    var sep = Math.max(digits.lastIndexOf('.'), digits.lastIndexOf(','));
    var normalised = (sep > -1 && digits.length - sep - 1 === 2)
      ? digits.slice(0, sep).replace(/[.,]/g, '') + '.' + digits.slice(sep + 1)
      : digits.replace(/[.,]/g, '');

    var value = parseFloat(normalised);
    if (!isFinite(value) || value <= 0) return null;
    return Math.round(value * 100);
  }

  function init(attempt) {
    if (document.getElementById('po-klarna-atc')) return;

    var source = document.querySelector('klarna-placement');
    var button = document.querySelector('.poc-atc');
    var form = button && button.closest('form');

    /* Klarna's block and the configurator both arrive asynchronously. */
    if (!source || !form) {
      if ((attempt || 0) < 20) setTimeout(function () { init((attempt || 0) + 1); }, 400);
      return;
    }

    var totalEl = document.querySelector('[data-poc-total]');

    var wrap = document.createElement('div');
    wrap.id = 'po-klarna-atc';
    wrap.style.marginTop = '10px';

    var placement = document.createElement('klarna-placement');

    function copyStatics() {
      for (var i = 0; i < COPIED.length; i++) {
        var value = source.getAttribute(COPIED[i]);
        if (value !== null) placement.setAttribute(COPIED[i], value);
      }
    }

    function wanted() {
      var cents = totalEl ? toCents(totalEl.textContent) : null;
      if (cents === null) cents = parseInt(source.getAttribute('data-purchase-amount'), 10);
      return isFinite(cents) && cents > 0 ? cents : null;
    }

    /* Conditional: only writes when Klarna's pass has left a different amount. */
    function applyAmount() {
      var want = wanted();
      if (want === null) return;
      if (parseInt(placement.getAttribute('data-purchase-amount'), 10) === want) return;
      placement.setAttribute('data-purchase-amount', String(want));
      refresh();
    }

    function settle() {
      for (var i = 0; i < SETTLE_DELAYS.length; i++) {
        setTimeout(applyAmount, SETTLE_DELAYS[i]);
      }
    }

    copyStatics();
    applyAmount();
    wrap.appendChild(placement);
    form.parentNode.insertBefore(wrap, form.nextSibling);
    refresh();
    settle();

    /* The summary total is rewritten as add-ons, quantity and variant change. */
    if (window.MutationObserver && totalEl) {
      new MutationObserver(settle).observe(totalEl, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    /* Locale/key can change with the market. The amount stays ours. */
    if (window.MutationObserver) {
      new MutationObserver(function () {
        copyStatics();
        refresh();
      }).observe(source, { attributes: true, attributeFilter: COPIED });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(0); });
  } else {
    init(0);
  }
})();